import tour1Gif from '../../../assets/images/tour-images/tour-1.gif';
import tour2Gif from '../../../assets/images/tour-images/tour-2.gif';
import tour3Gif from '../../../assets/images/tour-images/tour-3.gif';
import tour4Gif from '../../../assets/images/tour-images/tour-4.gif';
import tour5Gif from '../../../assets/images/tour-images/tour-5.gif';

export const tourText = {
  homeWelcome: {
    title:
      'Welcome to tapybl — your all-in-one platform for AI-powered learning creation',
    description:
      'Build videos, microlessons, and courses through prompt or your own library with the power of AI learning creation. ',
    image: tour1Gif,
  },
  microLessonsCard: {
    title: 'Microlessons',
    description:
      'Turn your prompts or existing library videos into impactful bite-sized learning content. ',
    image: tour2Gif,
    link: {
      label: 'Watch how to create a microlesson',
      url: 'https://www.youtube.com/watch?v=6TFOW-TYpd4',
    },
  },
  videosCard: {
    title: 'Videos ',
    description:
      'Generate AI-powered videos from documents, create microlessons within the same workflow, and personalize the experience with your AI assistant.',
    image: tour3Gif,
    link: {
      label: 'Watch how to create a video',
      url: 'https://www.youtube.com/watch?v=CYX5f86zYRM',
    },
  },
  coursesCard: {
    title: 'Courses ',
    description:
      'Create structured learning journeys by combining videos, microlessons, and interactive content into one seamless course.',
    image: tour4Gif,
    link: {
      label: 'Watch how to create a course',
      url: 'https://www.youtube.com/watch?v=A4yiZ9i1eBg',
    },
  },
  aiAssistantsCard: {
    title: 'AI assistant ',
    description:
      'Create your personalised AI assistant to generate, enhance, and support your learning content.',
    image: tour5Gif,
    link: {
      label: 'Watch how to create an AI assistant',
      url: 'https://www.youtube.com/watch?v=q9wKZAIpUyQ',
    },
  },
};
